import { ModalOrDrawerBodyWithMask } from '@ui/components/ModalOrDrawer';

import { useDisclaimerDrawer } from './DisclaimerDrawer';
import { ProtocolCard } from './ProtocolCard';
import { useUseYourTokenDrawer } from './useUseYourTokenDrawer';

export const DefaultContent = () => {
  const openDisclaimerDrawer = useDisclaimerDrawer((s) => s.onOpen);
  const protocols = useUseYourTokenDrawer((s) => s.protocols);
  return (
    <ModalOrDrawerBodyWithMask maskHeight={60}>
      {protocols.map((protocol, i) => {
        return (
          <ProtocolCard
            key={i}
            mb="16px"
            {...protocol}
            onClick={() => {
              openDisclaimerDrawer({
                url: protocol.url,
              });
            }}
          />
        );
      })}
    </ModalOrDrawerBodyWithMask>
  );
};
